import TranquilContentIcon from "./tranquilIconData"
import img4886 from "../../assets/BearishOSTranquilAI/Group 4886@2x.png";
const TraquilAISecondSection = ()=>{
    return (
        <div className="beba_3rd_section tranq_2_sec">
        <div className="beba_3rd_sect_img tranq_2_sec_img">
          <img alt="img" className="fo_img" src={img4886} />
        </div>
        <div className="sm_4th_sec beba_4rd_section">
          <div className="heading_30_41_left_blk sm_4th_header   tranq_2_sec_heading">
            Emotional Intelligence Redefined: Tranquil AI’s Mood Monitoring and
            Stress Management
          </div>
          <div className="fs_18_h_25_left_blk tranq_2_sec_content ">
            Tranquil AI brings a new level of emotional intelligence to the
            workplace. Using advanced algorithms, it monitors mood patterns and
            offers real-time stress management solutions. By understanding
            individual emotional needs, Tranquil AI provides tailored
            recommendations to maintain a healthy mental state. It’s not just
            about managing workloads; it’s about nurturing the emotional
            well-being of every team member
          </div>
          <div className="sim_4th_ico_cont">
            {TranquilContentIcon?.map((data, i) => (
              <div className="rs_last_icon_" key={i}>
                <div className="con_icon">
                  <img className="img_w" alt="icon" src={data?.icon} />
                </div>
                <div
                  className={`fs_18_h_25_left_blk beba_4rd_section_ico_content`}
                >
                  {" "}
                  <span className={`w_600`}>{data?.boldContent}</span>
                  {data?.content}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    )
}
export default TraquilAISecondSection;